export default "__VITE_ASSET__BUCBiQAf__"